export function counter(item) {
  const input = item.querySelector('input');
  ;[].forEach.call(item.querySelectorAll("[data-button]"), button => {
    button.addEventListener('click', () => {
      let max_val = input.getAttribute("max");
      let min_val = input.getAttribute("min");
      let old_val = parseInt(input.value);
      input.value = (old_val + (+(button.dataset.button + 1))).toString();
      if(parseInt(input.value) < 1) { input.value = '1' }
      if(parseInt(input.value) < min_val || parseInt(input.value) > max_val) { input.value = old_val }
      let event = new Event("input");
      input.dispatchEvent(event);
    })
  })
}
